import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { EuTaxonomyType } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'EuTaxonomyPicker',
  props: {
    value: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["input"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var taxonomies = computed(function () {
      return [{
        value: EuTaxonomyType.BiodiversityAndEcosystems,
        icon: 'biodiversity_and_ecosystems',
        label: $i18n.t('impactGoal.impacts.defineImpacts.classifyImpact.euTaxonomies.biodiversityAndEcosystems')
      }, {
        value: EuTaxonomyType.CircularEconomy,
        icon: 'circular_economy',
        label: $i18n.t('impactGoal.impacts.defineImpacts.classifyImpact.euTaxonomies.circularEconomy')
      }, {
        value: EuTaxonomyType.ClimateChangeAdaptation,
        icon: 'climate_change_adaptation',
        label: $i18n.t('impactGoal.impacts.defineImpacts.classifyImpact.euTaxonomies.climateChangeAdaptation')
      }, {
        value: EuTaxonomyType.ClimateChangeMitigation,
        icon: 'climate_change_mitigation',
        label: $i18n.t('impactGoal.impacts.defineImpacts.classifyImpact.euTaxonomies.climateChangeMitigation')
      }, {
        value: EuTaxonomyType.PollutionPrevention,
        icon: 'pollution_prevention',
        label: $i18n.t('impactGoal.impacts.defineImpacts.classifyImpact.euTaxonomies.pollutionPrevention')
      }, {
        value: EuTaxonomyType.WaterAndMarineResources,
        icon: 'water_and_marine_resources',
        label: $i18n.t('impactGoal.impacts.defineImpacts.classifyImpact.euTaxonomies.waterAndMarineResources')
      }];
    });
    var selectedTaxonomy = computed(function () {
      var _props$value;
      return (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : null;
    });
    var isSelected = function isSelected(value) {
      return selectedTaxonomy.value === value;
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      $i18n: $i18n,
      taxonomies: taxonomies,
      selectedTaxonomy: selectedTaxonomy,
      isSelected: isSelected
    };
  }
});